import React from 'react';
import { Link } from 'react-router-dom';

const TermsOfService = () => (
  <div className="max-w-3xl mx-auto">
    <h1 className="text-2xl sm:text-3xl font-bold tracking-tight text-ink-900 mb-2">Terms of Service</h1>
    <p className="text-sm text-ink-500 mb-8">Last updated: 11 June 2026</p>

    <div className="space-y-8 text-sm text-ink-700 leading-relaxed">
      <section>
        <h2 className="text-lg font-semibold text-ink-900 mb-2">1. The service</h2>
        <p>Dynalink provides URL shortening, link-in-bio profile pages, QR codes, and click analytics. By creating an account you agree to these terms and our <Link className="text-brand-600 underline" to="/privacy">Privacy Policy</Link>.</p>
      </section>

      <section>
        <h2 className="text-lg font-semibold text-ink-900 mb-2">2. Your account</h2>
        <p>You are responsible for keeping your credentials secure and for all activity under your account. You must provide a valid email address and be legally able to enter this agreement. We recommend enabling two-factor authentication.</p>
      </section>

      <section>
        <h2 className="text-lg font-semibold text-ink-900 mb-2">3. Acceptable use</h2>
        <p className="mb-2">You may not use Dynalink to create links or pages that point to or contain:</p>
        <ul className="list-disc pl-5 space-y-1">
          <li>malware, phishing, or credential-harvesting content;</li>
          <li>content that is illegal in your jurisdiction or ours;</li>
          <li>spam, deceptive redirects, or content that misrepresents its destination;</li>
          <li>material that infringes others' intellectual-property or privacy rights.</li>
        </ul>
        <p className="mt-2">We may disable links or suspend accounts that violate these rules, with or without notice. Destination URLs are restricted to http/https schemes and are rate-limited to prevent abuse.</p>
      </section>

      <section>
        <h2 className="text-lg font-semibold text-ink-900 mb-2">4. Your content</h2>
        <p>You retain ownership of the content you create. You grant us the limited licence needed to host, display, and redirect it — that is, to operate the service. You are responsible for the destinations your links point to.</p>
      </section>

      <section>
        <h2 className="text-lg font-semibold text-ink-900 mb-2">5. Service availability</h2>
        <p>The service is provided "as is" without warranties of uninterrupted availability. We may modify or discontinue features with reasonable notice. You can export your data at any time from your profile page.</p>
      </section>

      <section>
        <h2 className="text-lg font-semibold text-ink-900 mb-2">6. Termination</h2>
        <p>You may delete your account at any time from your profile page, which permanently erases your data. We may terminate accounts that violate these terms. Sections that by their nature survive termination (liability, governing law) do so.</p>
      </section>

      <section>
        <h2 className="text-lg font-semibold text-ink-900 mb-2">7. Liability</h2>
        <p>To the maximum extent permitted by law, we are not liable for indirect or consequential damages, loss of profits, or loss of data arising from use of the service. Our total liability is limited to the amount you paid us in the twelve months preceding the claim.</p>
      </section>

      <section>
        <h2 className="text-lg font-semibold text-ink-900 mb-2">8. Contact</h2>
        <p>Questions about these terms: <a className="text-brand-600 underline" href="mailto:dhanasekar.rohith@gmail.com">dhanasekar.rohith@gmail.com</a>.</p>
      </section>
    </div>
  </div>
);

export default TermsOfService;
